import { FallbackProps } from "react-error-boundary";
import { logger } from "../services/logger";
import { useAppContext } from "./AppContextProvider";

export const ErrorFallback = ({ error, resetErrorBoundary }: FallbackProps) => {
    // Log the error details
      const { updateLoading } = useAppContext();
    const errorObj = error as Error;
    
    const logError = async () => {
        logger.logToApi({
            type: "Error",
            source: errorObj.name|| "ErrorFallback",
            eventCode: errorObj.name|| "ErrorFallback",
            error: `${errorObj.name}\n${errorObj.message}\n${errorObj.stack}`,
        });
        console.log("Error logged to API:");
        console.log(error)
        logger.logToAppInsights(error as Error, 3);
    };
    logError();

    return (
        <div >
            <h2>Something went wrong:</h2>
            <p>{errorObj.message}</p>
            <button onClick={resetErrorBoundary}>Try again</button>
            <p>
                If the problem persists, please contact support or try again later.
            </p>
        </div>
    );
};